/* External Imports */
import { Box, Text, useBreakpointValue } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';

/* Styles */
import styles from "@lb/Sections/aboutDevi/styles.module.css"

const DeviSlide10 = () => {
  return (
    <Box
      background={useBreakpointValue({
        base: 'none',
        lg: `#000 url(${config.imgPath}/d/46272/1684474737-ib_secion10bg.jpg) no-repeat center top`,
      })}
      bgSize="cover !important"
      bgColor="#000"
      className={styles.section10Bg}
      overflow="hidden"
    >
      <Box
        maxW="1200px"
        width="100%"
        minH="100vh"
        py={{ base: 6, md: '1rem' }}
        mx="auto"
      >
        <Box
          w="100%"
          pos={{ base: 'static', md: 'relative' }}
          top={{ base: '0rem', md: '9rem' }}
          right="0rem"
          display="flex"
          px={{ base: 4, md: 7 }}
          minH={{ base: '', md: '', lg: '42rem', xl: '' }}
        >
          <Text
            pos={{ base: 'static', md: 'relative' }}
            w={{ base: '90%', md: '22rem', lg: '27rem' }}
            color="#fff"
            fontSize={{ base: '18px', lg: '24px' }}
            textAlign={{ base: 'center', md: 'start' }}
            py={{ base: '3rem', md: '0' }}
          >
            Every village{' '}
            <span style={{ color: '#D09700' }}>
              {' '}
              had a feminine deity to assist people with different aspects of
              their lives.{' '}
            </span>
          </Text>
        </Box>
        <Box
          pt={{ base: 4, md: '0px' }}
          display={{ base: 'block', lg: 'none' }}
        >
          <LazyLoadImageComponent
            src={`${config.imgPath}/d/46272/1684474737-ib_secion10bg.jpg`}
            alt="Ib_secion10bg"
          />
        </Box>
      </Box>
    </Box>
  );
};
export default DeviSlide10;
